export const ALBUMS_UPDATED_EVENT = 'albums:updated'

export function notifyAlbumsUpdated() {
  window.dispatchEvent(new Event(ALBUMS_UPDATED_EVENT))
}
